<template>
<div class="chapter">
<div class="inner_page">
<div class="toc">
<a id="title14"><h1 class="title">Table of Contents</h1>
</a><div class="toc_entry"><a id="title14"><br/>
</a><span class="toc_entry_titlePage" href="#/e9781439631850_tp01" title="Link target outside of Sample"><span>Title Page</span></span><br/>
<span class="toc_entry_pubInfo" href="#/e9781439631850_cop01" title="Link target outside of Sample"><span>Copyright Page</span></span><br/>
<span class="toc_entry_frontMatter" href="#/e9781439631850_fm02" title="Link target outside of Sample"><span>OTHER PUBLICATIONS BY LIONEL D. WYLD:</span></span><br/>
<a class="toc_entry_frontMatter" href="#/e9781439631850_fm03"><span><strong class="b">Introduction</strong></span></a><br/>
<a class="toc_entry_chapter" href="#/e9781439631850_c01"><span><em class="i">One</em> - From Colonial Times to the Naval Torpedo Station</span></a><br/>
<span class="toc_entry_chapter" href="#/e9781439631850_c02" title="Link target outside of Sample"><span><em class="i">Two</em> - Torpedoes and Torpedo Boats</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439631850_c03" title="Link target outside of Sample"><span><em class="i">Three</em> - The Naval Training Station and Naval War College</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439631850_c04" title="Link target outside of Sample"><span><em class="i">Four</em> - The Navy in Newport: 1900–1940</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439631850_c05" title="Link target outside of Sample"><span><em class="i">Five</em> - The Navy in Newport in World War II</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439631850_c06" title="Link target outside of Sample"><span><em class="i">Six</em> - Postwar Consolidation and Change</span></span><br/>
<span class="toc_entry_chapter" href="#/e9781439631850_c07" title="Link target outside of Sample"><span><em class="i">Seven</em> - Epilogue</span></span><br/>
<span class="toc_entry_acknowPage" href="#/e9781439631850_ack01" title="Link target outside of Sample"><span><strong class="b">Acknowledgments</strong></span></span><br/></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// e9781439631850_toc01.vue?2e8ad186